import { trackingConfig, dlog } from "@/config/trackingConfig";

const addScript = (src) => {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
  return s;
};

// Stubs are installed immediately so no event is lost; the heavy scripts load after the page is idle.
export function installStubs() {
  window.dataLayer = window.dataLayer || [];
  const { META_PIXEL_ID, GA4_ID, GTM_ID } = trackingConfig;
  if (GTM_ID) window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
  if (META_PIXEL_ID && !window.fbq) {
    const n = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!window._fbq) window._fbq = n;
    n.push = n; n.loaded = true; n.version = "2.0"; n.queue = [];
    window.fbq("init", META_PIXEL_ID);
  }
  if (GA4_ID && !window.gtag) {
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID, { send_page_view: false });
  }
}

export function loadScripts() {
  const { GTM_ID, META_PIXEL_ID, GA4_ID } = trackingConfig;
  const run = () => {
    if (GTM_ID) { addScript(`https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`); dlog("gtm", "loaded", GTM_ID); }
    if (META_PIXEL_ID) { addScript("https://connect.facebook.net/en_US/fbevents.js"); dlog("pixel", "loaded", META_PIXEL_ID); }
    if (GA4_ID) { addScript(`https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`); dlog("ga4", "loaded", GA4_ID); }
    if (!GTM_ID && !META_PIXEL_ID && !GA4_ID) dlog("init", "no tracking IDs configured; dataLayer only");
  };
  const idle = () => (window.requestIdleCallback ? window.requestIdleCallback(run, { timeout: 2500 }) : setTimeout(run, 1200));
  if (document.readyState === "complete") idle();
  else window.addEventListener("load", idle, { once: true });
}

export const scriptStatus = () => ({
  gtm: { configured: !!trackingConfig.GTM_ID, loaded: !!window.google_tag_manager },
  pixel: { configured: !!trackingConfig.META_PIXEL_ID, loaded: !!(window.fbq && window.fbq.callMethod) },
  ga4: { configured: !!trackingConfig.GA4_ID, loaded: !!(window.google_tag_data && window.gtag && trackingConfig.GA4_ID) },
});
